(function () {
  if (window.__araceliGwpBound) return;
  window.__araceliGwpBound = true;

  var YELLOW_VID = 50532391878912;
  var BLUE_VID = 50532391977216;
  var GIFT_VIDS = [YELLOW_VID, BLUE_VID];
  var GIFT_PIDS = [10201370296576, 10201370394880];
  // Only real section IDs. Fake names (main-cart-items, cart-icon-bubble)
  // make Shopify return sections: null for the whole payload.
  var busy = false;
  var checkoutPass = false;

  function isGiftLine(line) {
    var props = (line && line.properties) || {};
    return (
      GIFT_VIDS.indexOf(line.variant_id) !== -1 ||
      GIFT_PIDS.indexOf(line.product_id) !== -1 ||
      props._gwp === true ||
      props._gwp === 'true' ||
      props._gwp === '1' ||
      props._gwp === 1
    );
  }

  function analyze(cart) {
    var gifts = [];
    var paid = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (isGiftLine(items[i])) gifts.push(items[i]);
      else paid.push(items[i]);
    }
    var yellow = 0;
    var blue = 0;
    for (var g = 0; g < gifts.length; g++) {
      if (gifts[g].variant_id === YELLOW_VID || gifts[g].product_id === GIFT_PIDS[0]) yellow += gifts[g].quantity;
      if (gifts[g].variant_id === BLUE_VID || gifts[g].product_id === GIFT_PIDS[1]) blue += gifts[g].quantity;
    }
    return {
      gifts: gifts,
      paid: paid,
      hasPaid: paid.length > 0,
      yellow: yellow,
      blue: blue,
      bothGifts: yellow > 0 && blue > 0,
      giftAlone: gifts.length > 0 && paid.length === 0
    };
  }

  function invalid(a) {
    return a.giftAlone || a.bothGifts;
  }

  function parseJson(text) {
    try {
      return text ? JSON.parse(text) : null;
    } catch (e) {
      return null;
    }
  }

  function setBusyFlag(on) {
    window.__araceliGwpBusy = !!on;
  }

  function cartGet() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      return r.json();
    });
  }

  function liveSectionIds() {
    var ids = ['mini-cart'];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset && items.dataset.id) ids.push(items.dataset.id);
    if (footer && footer.dataset && footer.dataset.id) ids.push(footer.dataset.id);
    return ids;
  }

  function sectionsUrl() {
    return document.getElementById('main-cart-items') ? '/cart' : '/';
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) {
        var data = parseJson(t);
        if (!r.ok) {
          var err = new Error('gwp ' + url + ' ' + r.status);
          err.status = r.status;
          err.body = t.slice(0, 400);
          throw err;
        }
        return data;
      });
    });
  }

  function addGift(variantId) {
    return postJson('/cart/add.js?kaching_bundles=true', {
      id: variantId,
      quantity: 1,
      properties: { _gwp: '1' },
      sections: liveSectionIds().join(','),
      sections_url: sectionsUrl()
    });
  }

  function changeLine(key, qty) {
    return postJson('/cart/change.js', { id: key, quantity: qty });
  }

  function parseDoc(html) {
    return new DOMParser().parseFromString(html || '', 'text/html');
  }

  function replaceById(id, html) {
    var live = document.getElementById(id);
    if (!live || !html) return false;
    var doc = parseDoc(html);
    var fresh = doc.getElementById(id);
    if (fresh) {
      live.innerHTML = fresh.innerHTML;
      if (fresh.className) live.className = fresh.className;
      return true;
    }
    return false;
  }

  function injectMiniCart(html) {
    var root = document.getElementById('mini-cart') || document.querySelector('mini-cart');
    if (!root || !html) return false;
    var doc = parseDoc(html);
    var freshRoot = doc.getElementById('mini-cart');
    if (freshRoot) {
      root.innerHTML = freshRoot.innerHTML;
      return true;
    }
    var wrap = doc.querySelector('.shopify-section');
    if (wrap) {
      root.innerHTML = wrap.innerHTML;
      return true;
    }
    return false;
  }

  function injectCartPage(html) {
    if (!html) return false;
    var painted = false;
    if (replaceById('main-cart-items', html)) painted = true;
    if (replaceById('main-cart-footer', html)) painted = true;
    var itemsHost = document.querySelector('#shopify-section-cart-items, [id$="__cart-items"]');
    var footerHost = document.querySelector('#shopify-section-cart-footer, [id$="__cart-footer"]');
    var doc = parseDoc(html);
    var freshSection = doc.querySelector('.shopify-section');
    if (!painted && itemsHost && freshSection && html.indexOf('main-cart-items') !== -1) {
      itemsHost.innerHTML = freshSection.innerHTML;
      painted = true;
    }
    if (!painted && footerHost && freshSection && html.indexOf('main-cart-footer') !== -1) {
      footerHost.innerHTML = freshSection.innerHTML;
      painted = true;
    }
    return painted;
  }

  function applyReturnedSections(sections) {
    if (!sections) return { drawer: false, cart: false };
    var drawer = false;
    var cart = false;
    var mini = document.querySelector('mini-cart');
    if (sections['mini-cart']) {
      if (mini && typeof mini.applySections === 'function') {
        mini.applySections({ 'mini-cart': sections['mini-cart'] });
        drawer = true;
      } else if (injectMiniCart(sections['mini-cart'])) {
        drawer = true;
      }
    }
    var keys = Object.keys(sections);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (key === 'mini-cart') continue;
      var html = sections[key];
      if (injectCartPage(html)) cart = true;
      var dest = document.getElementById('shopify-section-' + key);
      if (dest && html) {
        var doc = parseDoc(html);
        var fresh = doc.getElementById('shopify-section-' + key) || doc.querySelector('.shopify-section, section.shopify-section');
        if (fresh) {
          dest.innerHTML = fresh.innerHTML;
          cart = true;
        }
      }
    }
    return { drawer: drawer, cart: cart };
  }

  function paintSelected(variantId) {
    variantId = Number(variantId || 0);
    var btns = document.querySelectorAll('[data-gwp-pick], [data-gwp-choice]');
    for (var i = 0; i < btns.length; i++) {
      var vid = parseInt(btns[i].getAttribute('data-gwp-pick') || btns[i].getAttribute('data-gwp-variant'), 10);
      var on = variantId && vid === variantId;
      btns[i].classList.toggle('is-selected', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function paintCount(count) {
    var hosts = document.querySelectorAll('#cart-icon-bubble');
    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h];
      var bubble = host.querySelector('.cart-count-bubble');
      if (count <= 0) {
        if (bubble) bubble.remove();
        continue;
      }
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'cart-count-bubble';
        host.appendChild(bubble);
      }
      var vis = bubble.querySelector('span[aria-hidden="true"]');
      if (!vis) {
        vis = document.createElement('span');
        vis.setAttribute('aria-hidden', 'true');
        bubble.insertBefore(vis, bubble.firstChild);
      }
      vis.textContent = String(count);
    }
  }

  function fallbackRefresh() {
    var jobs = [];
    var mini = document.querySelector('mini-cart');
    if (mini && typeof mini.refreshFromServer === 'function') {
      jobs.push(Promise.resolve(mini.refreshFromServer()));
    }
    if (document.getElementById('main-cart-items') || document.getElementById('main-cart-footer')) {
      var ids = [];
      var items = document.getElementById('main-cart-items');
      var footer = document.getElementById('main-cart-footer');
      if (items && items.dataset && items.dataset.id) ids.push(items.dataset.id);
      if (footer && footer.dataset && footer.dataset.id) ids.push(footer.dataset.id);
      jobs.push(
        fetch('/cart?sections=' + ids.join(',') + '&_=' + Date.now(), {
          credentials: 'same-origin',
          cache: 'no-store'
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (sections) {
            applyReturnedSections(sections);
          })
          .catch(function (err) {
            console.error('gwp cart fallback', err);
          })
      );
    }
    return Promise.all(jobs);
  }

  function afterAdd(added, selectedVid) {
    var painted = applyReturnedSections(added && added.sections);
    var needFallback =
      (document.getElementById('mini-cart') && !painted.drawer) ||
      ((document.getElementById('main-cart-items') || document.getElementById('main-cart-footer')) && !painted.cart);
    var next = needFallback ? fallbackRefresh() : Promise.resolve();
    return next
      .then(function () {
        paintSelected(selectedVid);
        document.dispatchEvent(new CustomEvent('cartdrawer:rendered'));
        return cartGet();
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') paintCount(cart.item_count);
        paintSelected(selectedVid);
        var mini = document.querySelector('mini-cart');
        if (mini && typeof mini.open === 'function') {
          try {
            mini.open();
          } catch (e) {}
        }
        return cart;
      });
  }

  function markBusy(on) {
    setBusyFlag(on);
    var btns = document.querySelectorAll('[data-gwp-pick], [data-gwp-choice]');
    for (var i = 0; i < btns.length; i++) {
      if (on) {
        btns[i].classList.add('is-busy');
        btns[i].disabled = true;
      } else {
        btns[i].classList.remove('is-busy');
        btns[i].disabled = false;
      }
    }
  }

  function pick(variantId) {
    variantId = Number(variantId);
    if (!variantId || busy) return Promise.resolve();
    busy = true;
    markBusy(true);
    return cartGet()
      .then(function (cart) {
        var a = analyze(cart);
        if (!a.hasPaid) return { skip: true, cart: cart };
        var already =
          a.gifts.length === 1 &&
          Number(a.gifts[0].variant_id) === variantId &&
          Number(a.gifts[0].quantity) === 1;
        if (already) return { skip: true, cart: cart, selected: variantId };
        var chain = Promise.resolve();
        a.gifts.forEach(function (g) {
          chain = chain.then(function () {
            return changeLine(g.key, 0);
          });
        });
        return chain
          .then(function () {
            return addGift(variantId);
          })
          .then(function (added) {
            return { skip: false, added: added, selected: variantId };
          });
      })
      .then(function (result) {
        if (!result || result.skip) {
          if (result && result.selected) paintSelected(result.selected);
          return result && result.cart;
        }
        return afterAdd(result.added, result.selected);
      })
      .catch(function (err) {
        console.error('gwp pick', err);
        return fallbackRefresh().then(function () {
          paintSelected(variantId);
        });
      })
      .then(function () {
        busy = false;
        markBusy(false);
        paintSelected(variantId);
        setTimeout(function () {
          if (!busy) setBusyFlag(false);
        }, 1600);
      });
  }

  function enforce() {
    if (busy) return Promise.resolve();
    busy = true;
    setBusyFlag(true);
    return cartGet()
      .then(function (cart) {
        var a = analyze(cart);
        var chain = Promise.resolve();
        var changed = false;
        if (a.giftAlone) {
          a.gifts.forEach(function (g) {
            chain = chain.then(function () {
              return changeLine(g.key, 0);
            });
            changed = true;
          });
        } else if (a.bothGifts) {
          var keepVid = a.gifts[0].variant_id;
          a.gifts.forEach(function (g) {
            if (g.variant_id !== keepVid) {
              chain = chain.then(function () {
                return changeLine(g.key, 0);
              });
              changed = true;
            } else if (g.quantity > 1) {
              chain = chain.then(function () {
                return changeLine(g.key, 1);
              });
              changed = true;
            }
          });
        } else if (a.gifts.length === 1 && a.gifts[0].quantity > 1) {
          chain = chain.then(function () {
            return changeLine(a.gifts[0].key, 1);
          });
          changed = true;
        }
        return chain.then(function () {
          return changed;
        });
      })
      .catch(function (err) {
        console.error('gwp enforce', err);
        return false;
      })
      .then(function (changed) {
        var p = changed ? fallbackRefresh() : Promise.resolve();
        return p.then(function () {
          busy = false;
          setBusyFlag(false);
        });
      });
  }

  function shouldBlockFrom(cart) {
    return invalid(analyze(cart));
  }

  document.addEventListener(
    'click',
    function (e) {
      var pickBtn = e.target.closest('[data-gwp-pick], [data-gwp-choice]');
      if (pickBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        var vid = parseInt(pickBtn.getAttribute('data-gwp-pick') || pickBtn.getAttribute('data-gwp-variant'), 10);
        if (vid) pick(vid);
        return;
      }

      var checkoutEl = e.target.closest('button[name="checkout"], [name="checkout"], a[href*="/checkout"]');
      if (!checkoutEl) return;
      if (checkoutPass) return;
      e.preventDefault();
      e.stopPropagation();
      cartGet().then(function (cart) {
        if (shouldBlockFrom(cart)) {
          return enforce();
        }
        checkoutPass = true;
        if (checkoutEl.tagName === 'A') {
          window.location.href = checkoutEl.getAttribute('href') || '/checkout';
        } else {
          window.location.href = '/checkout';
        }
      });
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || checkoutPass) return;
      var isCart = form.id === 'cart' || (form.getAttribute('action') || '').indexOf('/cart') !== -1;
      if (!isCart) return;
      var submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      e.preventDefault();
      e.stopPropagation();
      cartGet().then(function (cart) {
        if (shouldBlockFrom(cart)) {
          return enforce();
        }
        checkoutPass = true;
        window.location.href = '/checkout';
      });
    },
    true
  );

  function scheduleEnforce() {
    if (window.__araceliGwpBusy) return;
    setTimeout(function () {
      if (window.__araceliGwpBusy) return;
      enforce();
    }, 600);
  }

  document.addEventListener('cartdrawer:opened', scheduleEnforce);

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('cart-remove-button, quantity-input, [name="minus"], [name="plus"]')) {
        scheduleEnforce();
      }
    },
    false
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnforce);
  } else {
    scheduleEnforce();
  }
})();
